module.exports = __webpack_public_path__ + "img/slider_15.fab5e8e0.jpg";